/*eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore.dev';
import {Provider} from 'react-redux';
//USE HASH HISTORY BECAUSE THIS WILL NEED WORK LOCALLY WITH OUT A SERVER ENVIROMENT
import { Router, hashHistory } from 'react-router';
import routes from './routes';

//import {checkAuthentication} from './actions/authenticationActions';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css'; //Webpack can import CSS files too!
import '../node_modules/react-quill/dist/quill.snow.css';
import '../node_modules/react-quill/dist/quill.bubble.css';
import '../node_modules/react-quill/dist/quill.core.css';
import '../node_modules/video.js/dist/video-js.css';


//can pass initial state to configureStore();
export const store = configureStore();
//store.dispatch(checkAuthentication());



render(

    <Provider store={store}>
      <Router history={hashHistory} routes={routes} />
    </Provider>,
    document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/